import { combineReducers } from "redux";
import auth from "./auth";
import message from "./message";
import dev from "./dev"

export default combineReducers({
  auth,
  message,
  dev,
});
